<div class='iconInformation'>
        <div *ngIf="icon" class='iconInformation__icon'>               
                    <mat-icon [svgIcon]="icon" [ngStyle]="{'color': 'blue'}"></mat-icon>               
        </div>
         <div class='iconInformation__information'>
                <div class='iconInformation__information__title' *ngIf="title" [innerHtml]="title | safeHtml">
                </div>
                <div class='iconInformation__information__subtitle' [innerHtml]="subtitle | safeHtml">
                </div>    
        </div>

</div>
